import React from "react";
import { FaSearch, FaPlus } from "react-icons/fa";

/**
 * ÉTAT VIDE - Affiche un message quand aucun résultat
 * @param {Object} props
 * @param {boolean} props.hasSearch - Si une recherche est active
 * @param {Function} props.onReset - Callback réinitialisation
 */
const EmptyState = ({ hasSearch, onReset }) => {
  return (
    <div className="text-center py-5 my-5">
      <div className="empty-state-icon mb-4">
        <FaSearch size={48} className="text-muted opacity-25" />
      </div>
      
      <h5 className="fw-semibold text-muted mb-3">
        {hasSearch ? "Aucun domaine trouvé" : "Aucun domaine"}
      </h5>
      
      <p className="text-muted mb-4">
        {hasSearch
          ? "Aucun résultat ne correspond à votre recherche. Veuillez modifier vos critères."
          : "Commencez par créer votre premier domaine."}
      </p>

      {hasSearch && (
        <button
          className="btn btn-outline-primary rounded-pill px-4"
          onClick={onReset}
        >
          <FaPlus className="me-2" />
          Réinitialiser la recherche
        </button>
      )}
    </div>
  );
};

export default EmptyState;